<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div @click="backPage" class="mt-racede-fff-back flex-row-align">
        <i class="el-icon-arrow-left"></i>返回
      </div>
      <div class="text item">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm" style="margin-top: 16px;">
          <el-form-item label="商品搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="goodsThumb"
            label="图片">
            <template slot-scope="scope">
              <el-image
                style="width: 32px;"
                :src="scope.row.goodsThumb"
                :preview-src-list="[scope.row.goodsThumb]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsSpecName"
            label="商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="buyNumber"
            label="商品数量">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryDealerOrderGoodsPageList  } from '@/api/distributor'
export default {
  name: 'AgentGoodsList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      let dealerOrderId = that.dataId
      queryDealerOrderGoodsPageList({ dealerOrderId: dealerOrderId, goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 添加商品页面 */
    addBtn () {
      this.$router.push('/activity_goods_add')
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/activity_goods_add', query: {dataId: infoId}})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeActiveGoodsById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/distributor/GoodsList.vue